import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useCachedMedium } from "./useCachedMedium";
import { useCachedTerreiro } from "./useCachedTerreiro";
import { inventoryItemByIdQueryKey } from "./useInventoryItemByIdQuery";
import {
  invalidateSupplyPlanQueries,
} from "./useSupplyPlanQuery";
import {
  mediumInventoryListQueryKey,
  terreiroInventoryListQueryKey,
} from "./useTerreiroInventoryListQuery";
import {
  inventoryItemRepository,
  type InventoryItemPayload,
} from "../repositories/inventoryItem.repository";

export const updateInventoryItemMutationKey = (inventoryItemId: string) => [
  "inventory-item",
  inventoryItemId,
  "update",
];

export function useUpdateInventoryItemMutation(inventoryItemId: string) {
  const queryClient = useQueryClient();
  const cachedTerreiro = useCachedTerreiro();
  const cachedMedium = useCachedMedium();

  return useMutation({
    mutationKey: updateInventoryItemMutationKey(inventoryItemId),
    mutationFn: (payload: InventoryItemPayload) =>
      inventoryItemRepository.updateInventoryItem(inventoryItemId, payload),
    onSuccess: (_data, payload) => {
      const terreiroId = payload.terreiroId ?? cachedTerreiro?.id;
      const mediumId = payload.mediumId ?? cachedMedium?.id;

      queryClient.invalidateQueries({
        queryKey: inventoryItemByIdQueryKey(inventoryItemId),
      });

      if (terreiroId) {
        queryClient.invalidateQueries({
          queryKey: terreiroInventoryListQueryKey(terreiroId),
        });
        invalidateSupplyPlanQueries(queryClient, terreiroId);
        return;
      }

      if (mediumId) {
        queryClient.invalidateQueries({
          queryKey: mediumInventoryListQueryKey(mediumId),
        });
        invalidateSupplyPlanQueries(queryClient, undefined, mediumId);
      }
    },
  });
}
